import React, { useContext } from "react";
import { Button, Modal, Typography } from "antd";
import MerchantEmployeeLayout from "../../layout/MerchantEmployeeLayout";
import { SubscriptionInfo, UserInfo } from "../../../context";
import moment from "moment";

const HomeEmployee = () => {
  const { handleLogoutTkn } = useContext(UserInfo);
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

  return (
    <MerchantEmployeeLayout>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          // border: "1px solid red",
          height: "100%",
        }}
      >
        <Typography style={{ fontSize: 24 }}>
          Please ask for your permission
        </Typography>
        <Typography>This is only a landing page for employee</Typography>
      </div>

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        // open={false}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </MerchantEmployeeLayout>
  );
};

export default HomeEmployee;
